import AxiosClient, { CancelTokenSource } from 'axios'
import routes from '@configs/api'
import { Resource } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Create Course lecture resource
 * @param course_id
 * @param version
 * @param fileName
 * @param resourceName
 * @param cancelToken
 */
const createCourseLectureResource = (
  course_id: string,
  version: number,
  fileName: string,
  resourceName: string,
  cancelToken?: CancelTokenSource
): Promise<Resource> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/resources'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
      cancelToken: cancelToken && cancelToken.token,
    }
    const data = { fileName, resourceName }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        if (AxiosClient.isCancel(err)) {
          reject(err)
        } else {
          reject(err)
        }
      })
  })
}

export default createCourseLectureResource
